import React from 'react';
import PricelistPDF from '../../assets/PricelistPDF.pdf';
import './services.css';
import { AiOutlineDownload} from 'react-icons/ai';
import ImageGallery from 'react-image-gallery';

const images = [
    {
      original: require('../../assets/slider/PricelistPDF1.jpg'),
      originalAlt: "Price list page 1",
      originalTitle: "Price list page 1",
      originalHeight: 689,
      originalWidth: 1200,
    },
    {
      original: require('../../assets/slider/PricelistPDF2.jpg'),
      originalAlt: "Price list page 2",
      originalTitle: "Price list page 2",
      originalHeight: 689,
      originalWidth: 1200,
    },
]

const Pricelist = () => {

  return (
    <section className='services section' id='price'>
      <h2 className='section__title'>Price List</h2>
      <h3 className='section__subtitle'>
        Our latest price list. You can view it here or download the PDF version.
      </h3>

      <div className='services__container container'>
        <div className='pricelist-slider'>
            <ImageGallery items={images} />
            <a download="" href={PricelistPDF} className='button button--flex pricelist-slider-button'>
                Download Full Price List <AiOutlineDownload />
            </a>
        </div>
      </div>
    </section>
  );
};

export default Pricelist;